import React, { useEffect, useRef, useState } from "react";

function HomeBox1() {

    const sectionRef = useRef(null);

    const [visible, setVisible] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [transition, setTransition] = useState(true);
    const [itemsToShow, setItemsToShow] = useState(4);

    // ===== CARDS =====

    const cards = [
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="#001e45" width="80px" height="80px"><path d="M96.5 160L96.5 309.5C96.5 326.5 103.2 342.8 115.2 354.8L307.2 546.8C332.2 571.8 372.7 571.8 397.7 546.8L547.2 397.3C572.2 372.3 572.2 331.8 547.2 306.8L355.2 114.8C343.2 102.7 327 96 310 96L160.5 96C125.2 96 96.5 124.7 96.5 160zM208.5 176C226.2 176 240.5 190.3 240.5 208C240.5 225.7 226.2 240 208.5 240C190.8 240 176.5 225.7 176.5 208C176.5 190.3 190.8 176 208.5 176z"></path></svg>
            ),
            title: "Full Brand Customization",
            text: "Design digital loyalty cards featuring your branding and custom rewards within minutes",
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="#001e45" width="80px" height="80px"><path d="M160 224L224 224L224 160L160 160L160 224zM96 144C96 117.5 117.5 96 144 96L240 96C266.5 96 288 117.5 288 144L288 240C288 266.5 266.5 288 240 288L144 288C117.5 288 96 266.5 96 240L96 144zM160 480L224 480L224 416L160 416L160 480zM96 400C96 373.5 117.5 352 144 352L240 352C266.5 352 288 373.5 288 400L288 496C288 522.5 266.5 544 240 544L144 544C117.5 544 96 522.5 96 496L96 400zM416 160L416 224L480 224L480 160L416 160zM400 96L496 96C522.5 96 544 117.5 544 144L544 240C544 266.5 522.5 288 496 288L400 288C373.5 288 352 266.5 352 240L352 144C352 117.5 373.5 96 400 96zM384 416C366.3 416 352 401.7 352 384C352 366.3 366.3 352 384 352C401.7 352 416 366.3 416 384C416 401.7 401.7 416 384 416zM384 480C401.7 480 416 494.3 416 512C416 529.7 401.7 544 384 544C366.3 544 352 529.7 352 512C352 494.3 366.3 480 384 480zM480 512C480 494.3 494.3 480 512 480C529.7 480 544 494.3 544 512C544 529.7 529.7 544 512 544C494.3 544 480 529.7 480 512zM512 416C494.3 416 480 401.7 480 384C480 366.3 494.3 352 512 352C529.7 352 544 366.3 544 384C544 401.7 529.7 416 512 416zM480 448C480 465.7 465.7 480 448 480C430.3 480 416 465.7 416 448C416 430.3 430.3 416 448 416C465.7 416 480 430.3 480 448z"></path></svg>
            ),
            title: "Quick Sign-Up",
            text: "Customers can join instantly using a QR code or direct wallet link",
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="#001e45" width="80px" height="80px"><path d="M320 224C355.3 224 384 197.1 384 164C384 140 350.3 93.9 331.8 70.5C325.7 62.8 314.3 62.8 308.2 70.5C289.7 93.9 256 140 256 164C256 197.1 284.7 224 320 224zM432 160C432 221.9 381.9 272 320 272C258.1 272 208 221.9 208 160C208 148.9 209.6 138.1 212.6 128L128 128C92.7 128 64 156.7 64 192L64 448C64 483.3 92.7 512 128 512L405.5 512C422.5 512 438.8 505.3 450.8 493.3L557.3 386.7C569.3 374.7 576 358.4 576 341.4L576 192C576 156.7 547.3 128 512 128L427.4 128C430.4 138.1 432 148.9 432 160zM517.5 336L400 453.5L400 360C400 346.7 410.7 336 424 336L517.5 336zM160 192C177.7 192 192 206.3 192 224C192 241.7 177.7 256 160 256C142.3 256 128 241.7 128 224C128 206.3 142.3 192 160 192z"></path></svg>
            ),
            title: "One-Tap Stamping",
            text: "Easily issue stamps and redeem rewards in moments with our Stamper App",
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="#001e45" width="80px" height="80px"><path d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM216 288C229.3 288 240 298.7 240 312L240 424C240 437.3 229.3 448 216 448C202.7 448 192 437.3 192 424L192 312C192 298.7 202.7 288 216 288zM400 376C400 362.7 410.7 352 424 352C437.3 352 448 362.7 448 376L448 424C448 437.3 437.3 448 424 448C410.7 448 400 437.3 400 424L400 376zM320 192C333.3 192 344 202.7 344 216L344 424C344 437.3 333.3 448 320 448C306.7 448 296 437.3 296 424L296 216C296 202.7 306.7 192 320 192z"></path></svg>
            ),
            title: "Real-Time Insights",
            text: "Monitor signups, rewards, and loyalty-driven ROI in one place",
        },
    ];

    // ===== CLONE FOR INFINITE SLIDER =====

    const sliderCards = [...cards, ...cards];

    // ===== RESPONSIVE ITEMS =====

    useEffect(() => {

        const handleResize = () => {

            if (window.innerWidth <= 768) {
                setItemsToShow(1);
            }
            else if (window.innerWidth <= 992) {
                setItemsToShow(2);
            }
            else {
                setItemsToShow(4);
            }

        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () =>
            window.removeEventListener("resize", handleResize);

    }, []);

    // ===== SECTION ANIMATION =====

    useEffect(() => {

        const observer = new IntersectionObserver(
            ([entry]) => {

                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }

            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();

    }, []);

    // ===== AUTO SLIDER FIX =====

    useEffect(() => {

        let interval;

        const startSlider = () => {

            interval = setInterval(() => {
                setCurrentSlide((prev) => prev + 1);
            }, 3000);

        };

        const stopSlider = () => {
            clearInterval(interval);
        };

        const handleVisibilityChange = () => {

            if (document.hidden) {
                stopSlider();
            }
            else {
                stopSlider();
                startSlider();
            }

        };

        startSlider();

        document.addEventListener(
            "visibilitychange",
            handleVisibilityChange
        );

        return () => {

            stopSlider();

            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
            );

        };

    }, []);

    // ===== INFINITE LOOP =====

    useEffect(() => {

        if (currentSlide >= cards.length) {

            setTimeout(() => {

                setTransition(false);
                setCurrentSlide(0);

            }, 700);

            setTimeout(() => {
                setTransition(true);
            }, 750);

        }

    }, [currentSlide, cards.length]);

    // ===== BUTTONS =====

    // const nextSlide = () => {
    //     setCurrentSlide((prev) => prev + 1);
    // };

    // const prevSlide = () => {

    //     if (currentSlide === 0) {

    //         setTransition(false);
    //         setCurrentSlide(cards.length - 1);

    //         setTimeout(() => {
    //             setTransition(true);
    //         }, 50);

    //     }
    //     else {
    //         setCurrentSlide((prev) => prev - 1);
    //     }

    // };

    return (

        <section
            className={`homebox1 ${visible ? "homebox1-visible" : ""}`}
            ref={sectionRef}
        >

            <div className="container">

                {/* ===== TITLE ===== */}

                <div className="homebox1-title">

                    <h1>
                        All-in-one platform for digital customer reward programs
                    </h1>

                    <p>
                        Craft loyalty cards, enroll clients, encourage return
                        visits, and track engagement
                    </p>

                </div>

                {/* ===== SLIDER ===== */}

                <div className="slider-wrapper">

                    {/* <button
                        className="slider-btn prev"
                        onClick={prevSlide}
                    >
                        ❮
                    </button> */}

                    <div className="homebox1-slider">

                        <div
                            className="homebox1-track"
                            style={{
                                transform: `translateX(-${currentSlide * (100 / itemsToShow)}%)`,
                                transition: transition
                                    ? "transform 0.7s ease-in-out"
                                    : "none",
                            }}
                        >

                            {sliderCards.map((card, index) => (

                                <div
                                    className="homebox1-item"
                                    key={index}
                                >

                                    {card.icon}

                                    <h3>{card.title}</h3>

                                    <p>{card.text}</p>

                                </div>

                            ))}

                        </div>

                    </div>

                    {/* <button
                        className="slider-btn next"
                        onClick={nextSlide}
                    >
                        ❯
                    </button> */}

                </div>

            </div>

        </section>

    );
}

export default HomeBox1;